import Api from '@/api/index'

const state = {
  all: [],
  products: [],
  emptyItems: [],
}

const getters = {
  products: state => {
    return state.products
  },
  emptyItems: state => {
    return state.emptyItems
  },
}

const actions = {
  async getAll({ commit }, params) {
    const invoices = await Api.Invoice.getAll(params)
    if (invoices !== null) {
      commit('setInvoices', invoices)
      return invoices
    }
    return []
  },

  async getById(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const Product = await Api.Invoice.getById(params)
    if (Product !== null) {
      return Product
    }
    return null
  },

  async save(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    Product
  ) {
    const result = await Api.Invoice.save(Product)
    return result
  },

  async delete(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Invoice.delete(params)
    return result
  },

  async caseReady(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Invoice.caseReady(params)
    return result
  },

  async getItems(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    let items = await Api.Invoice.getProducts(params)
    return items
  },

  resetEmptyItems({ commit }) {
    commit('setEmptyItems', [])
  },
}

const mutations = {
  setInvoices(state, invoices) {
    state.all = invoices.items
  },

  setProducts(state, products) {
    state.products = products
  },

  setEmptyItems(state, emptyItems) {
    state.emptyItems = emptyItems
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
